"use client"

import Script from "next/script"

const SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY?.trim()

declare global {
  interface Window {
    grecaptcha?: {
      ready(callback: () => void): void
      execute(siteKey: string, options: { action: string }): Promise<string>
    }
  }
}

export function RecaptchaScript() {
  return SITE_KEY ? (
    <Script
      id="recaptcha-v3"
      src={`https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`}
      strategy="afterInteractive"
    />
  ) : null
}

/** Generate a fresh, single-use token immediately before each form submission. */
export function getRecaptchaToken(action: string): Promise<string> {
  if (!SITE_KEY) return Promise.reject(new Error("not_configured"))
  return new Promise((resolve, reject) => {
    const timer = window.setTimeout(() => reject(new Error("captcha_unavailable")), 15_000)
    const fail = () => {
      window.clearTimeout(timer)
      reject(new Error("captcha_unavailable"))
    }
    const captcha = window.grecaptcha
    if (!captcha) return fail()
    try {
      captcha.ready(() => {
        try {
          captcha.execute(SITE_KEY, { action }).then((token) => {
            window.clearTimeout(timer)
            if (token) resolve(token)
            else reject(new Error("captcha_unavailable"))
          }, fail)
        } catch { fail() }
      })
    } catch { fail() }
  })
}
